"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm, { UiFormAnnotations, UiFormController } from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import PasswordInput from "@/views/accountItems/components/PasswordInput.vue";
import i18n from "@/lang";
import ProxyTransform from "@/utils/proxyTest";
import { Debounce } from "vue-debounce-decorator";
export class ProxySettingsForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.proxy_ip = "";
    this.proxy_port = 1080;
    this.proxy_account = "";
    this.proxy_password = "";
    this.proxy_account_http_or_socks = "";
    this.proxy_password_http_or_socks = "";
    this.proxy_method = "";
    this.proxy_protocol = "socks5";
    this.proxy_remote_ip = "";
    this.support_remote = false;
    this.remote = {
      address: "127.0.0.1",
      password: "",
      port: 0,
      username: ""
    };
  }
}
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: i18n.t("proxysettingsdialog.proxy_address_cannot_be_empty"),
    trigger: "blur"
  }])
], ProxySettingsForm.prototype, "proxy_ip", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("proxysettingsdialog.proxy_port_cannot_be_empty"),
      trigger: "blur"
    },
    {
      type: "number",
      message: i18n.t("proxysettingsdialog.the_proxy_port_must_be_a_number"),
      trigger: "blur"
    }
  ])
], ProxySettingsForm.prototype, "proxy_port", 2);
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: i18n.t("proxysettingsdialog.proxy_account_cannot_be_empty"),
    trigger: "blur"
  }])
], ProxySettingsForm.prototype, "proxy_account", 2);
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: i18n.t("proxysettingsdialog.proxy_password_cannot_be_empty"),
    trigger: "blur"
  }])
], ProxySettingsForm.prototype, "proxy_password", 2);
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: i18n.t("proxysettingsdialog.proxy_protocol_cannot_be_empty"),
    trigger: "blur"
  }])
], ProxySettingsForm.prototype, "proxy_protocol", 2);
class CheckData {
  constructor() {
    this.ip = "";
    this.status = "";
    this.message = "";
    this.country_iso_code = null;
  }
}
class QueryData {
  constructor() {
    this.proxy_protocol = "";
    this.proxy_port = 0;
    this.proxy_ip = "";
    this.proxy_method = null;
    this.proxy_account = null;
    this.proxy_password = null;
  }
}
let ProxySettingsDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.vdId = "";
    // rows:Array<any> = []
    this.dialogLoading = false;
    this.checkIpBtnLoading = false;
    this.testProxyBtnLoading = false;
    this.is_fake = false;
    this.dialog = new UiDialogController();
    this.checkdialog = new UiDialogController();
    this.controller = new ProxySettingsForm();
    this.checkData = new CheckData();
    this.proxyProtocols = [
      { "label": "SSH", "value": "ssh", "disable": false },
      { "label": "Socks5", "value": "socks5", "disable": false },
      { "label": "Http", "value": "http", "disable": false },
      { "label": "Https", "value": "https", "disable": false },
      { "label": "Shadowsocks", "value": "shadowsocks", "disable": true }
    ];
    this.proxyMethods = [
      { "label": "AES-256-CFB", "value": "AES-256-CFB", "disable": true },
      { "label": "AES-128-CFB", "value": "AES-128-CFB", "disable": true },
      { "label": "CHACHA20", "value": "CHACHA20", "disable": false },
      { "label": "CHACHA20-IETF", "value": "CHACHA20-IETF", "disable": false },
      { "label": "AES-256-GCM", "value": "AES-256-GCM", "disable": false },
      { "label": "AES-128-GCM", "value": "AES-128-GCM", "disable": false },
      { "label": "CHACHA20-POLY1305", "value": "CHACHA20-POLY1305", "disable": false },
      { "label": "CHACHA20-IETF-POLY1305", "value": "CHACHA20-IETF-POLY1305", "disable": false }
    ];
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  changeProtocol() {
    this.controller.proxy_account = "";
    this.controller.proxy_account_http_or_socks = "";
    this.controller.proxy_password = "";
    this.controller.proxy_password_http_or_socks = "";
  }
  submit() {
    return __async(this, null, function* () {
      try {
        let proxy_request = {
          vdGuid: this.vdId,
          proxys: []
        };
        proxy_request.proxys.push(
          __spreadValues(__spreadValues(__spreadValues({
            "protocol": this.controller.proxy_protocol,
            "address": this.controller.proxy_ip,
            "port": this.controller.proxy_port,
            "exportIp": this.controller.proxy_remote_ip === "" ? null : this.controller.proxy_remote_ip
          }, (() => {
            if (this.controller.proxy_protocol === "shadowsocks") {
              return {
                "method": this.controller.proxy_method
              };
            }
          })()), (() => {
            if (this.controller.proxy_protocol !== "shadowsocks" && this.controller.proxy_protocol !== "http" && this.controller.proxy_protocol !== "socks5") {
              return {
                "user": this.controller.proxy_account === "" ? null : this.controller.proxy_account
              };
            }
            if (this.controller.proxy_protocol === "http" || this.controller.proxy_protocol === "socks5") {
              return {
                "user": this.controller.proxy_account_http_or_socks === "" ? null : this.controller.proxy_account_http_or_socks
              };
            }
          })()), (() => {
            if (this.controller.proxy_protocol !== "http" && this.controller.proxy_protocol !== "socks5") {
              return {
                "pass": this.controller.proxy_password === "" ? null : this.controller.proxy_password
              };
            }
            if (this.controller.proxy_protocol === "http" || this.controller.proxy_protocol === "socks5") {
              return {
                "pass": this.controller.proxy_password_http_or_socks === "" ? null : this.controller.proxy_password_http_or_socks
              };
            }
          })())
        );
        if (this.controller.support_remote === true) {
          proxy_request.proxys.push(
            {
              "protocol": "rdp",
              "address": this.controller.remote.address,
              "port": this.controller.remote.port,
              "user": this.controller.remote.username,
              "pass": this.controller.remote.password
            }
          );
        }
        yield API.post(`api://base.auth.pro/v1/virtual-desktops/${this.vdId}/custom`, {
          "proxies": proxy_request.proxys
        });
        this.$message.success(this.$t("proxysettingsdialog.configuration_agent_succeeded"));
        this.$emit("success");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.close();
      }
    });
  }
  getProxySetting(id) {
    return __async(this, null, function* () {
      var _a;
      try {
        const response = yield API.get(`api://base.auth.pro/v1/virtual-desktops/${id}/custom`);
        for (const proxyItem of response.data.datas) {
          if (proxyItem.protocol === "rdp") {
            this.controller.support_remote = true;
            this.controller.remote.address = proxyItem.address;
            this.controller.remote.password = proxyItem.pass;
            this.controller.remote.port = proxyItem.port;
            this.controller.remote.username = proxyItem.user;
          } else {
            this.controller.proxy_ip = proxyItem.address;
            this.controller.proxy_method = (_a = proxyItem.method) != null ? _a : "";
            this.controller.proxy_port = proxyItem.port;
            this.controller.proxy_protocol = proxyItem.protocol;
            if (this.controller.proxy_protocol === "http" || this.controller.proxy_protocol === "socks5") {
              this.controller.proxy_password_http_or_socks = proxyItem.pass;
              this.controller.proxy_account_http_or_socks = proxyItem.user;
            }
            if (this.controller.proxy_protocol !== "http" && this.controller.proxy_protocol !== "socks5") {
              this.controller.proxy_account = proxyItem.user;
              this.controller.proxy_password = proxyItem.pass;
            }
            this.controller.proxy_remote_ip = proxyItem.exportIp === null ? "" : proxyItem.exportIp;
          }
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getQueryData() {
    return __async(this, null, function* () {
      let _data = new QueryData();
      _data.proxy_protocol = this.controller.proxy_protocol;
      _data.proxy_port = Number(this.controller.proxy_port);
      _data.proxy_ip = this.controller.proxy_ip;
      if (this.controller.proxy_protocol === "shadowsocks") {
        _data.proxy_method = this.controller.proxy_method;
      }
      if (this.controller.proxy_protocol !== "shadowsocks" && this.controller.proxy_account !== "" && this.controller.proxy_account !== null && this.controller.proxy_account !== void 0) {
        _data.proxy_account = this.controller.proxy_account;
      }
      if (this.controller.proxy_password !== "" && this.controller.proxy_password !== null && this.controller.proxy_password !== void 0) {
        _data.proxy_password = this.controller.proxy_password;
      }
      return _data;
    });
  }
  checkIp() {
    return __async(this, null, function* () {
      try {
        if (this.is_fake) {
          return;
        }
        this.checkIpBtnLoading = true;
        let _data = yield this.getQueryData();
        const _token_response = yield API.get("api://base.local/storages/preference/token");
        const _token = _token_response.data.value.token;
        const host = yield ProxyTransform.proxyTransform(_data);
        const proxy_response = yield API.post("api://base.local/crypto/encode", JSON.stringify(host), {
          headers: {
            "Content-Type": "application/json"
          }
        });
        const _proxy = proxy_response.data;
        const proxt_data = {
          "proxy_encrypt": _proxy.result,
          "request": {
            "url": "https://ipext.kuajingvs.com/api/v1/virtual_desktops/ip/check",
            "method": "GET",
            "headers": {
              "x-auth-token": _token
            }
          }
        };
        const response = yield API.post("api://base.local/proxies/forwarding", JSON.stringify(proxt_data), {
          headers: {
            "Content-Type": "application/json"
          }
        });
        this.checkData.ip = response.data.ip;
        this.checkData.status = response.data.status;
        this.checkData.message = response.data.message;
        this.checkData.country_iso_code = response.data.country_iso_code;
        this.checkdialog.visible = true;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.checkIpBtnLoading = false;
      }
    });
  }
  testProxy() {
    return __async(this, null, function* () {
      try {
        if (this.is_fake) {
          return;
        }
        this.testProxyBtnLoading = true;
        let _data = yield this.getQueryData();
        const _token_response = yield API.get("api://base.local/storages/preference/token");
        const _token = _token_response.data.value.token;
        const host = yield ProxyTransform.proxyTransform(_data);
        const proxy_response = yield API.post("api://base.local/crypto/encode", JSON.stringify(host), {
          headers: {
            "Content-Type": "application/json"
          }
        });
        const _proxy = proxy_response.data;
        const proxt_data = {
          "proxy_encrypt": _proxy.result,
          "request": {
            "url": "https://api.kuajingvs.com/v7/client/geo",
            "method": "GET",
            "headers": {
              "x-auth-token": _token
            }
          }
        };
        const response = yield API.post("api://base.local/proxies/forwarding", JSON.stringify(proxt_data), {
          headers: {
            "Content-Type": "application/json"
          }
        });
        this.$message.success(this.$t("proxysettingsdialog.your_agent_test_passed"));
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.testProxyBtnLoading = false;
      }
    });
  }
  open(vd) {
    return __async(this, null, function* () {
      this.vdId = vd.id;
      this.dialogLoading = false;
      this.checkIpBtnLoading = false;
      this.testProxyBtnLoading = false;
      this.controller = new ProxySettingsForm();
      yield this.getProxySetting(vd.id);
      this.dialog.visible = true;
    });
  }
  close() {
    this.dialog.visible = false;
    this.is_fake = false;
    this.proxyProtocols = [
      { "label": "SSH", "value": "ssh", "disable": false },
      { "label": "Socks5", "value": "socks5", "disable": false },
      { "label": "Http", "value": "http", "disable": false },
      { "label": "Https", "value": "https", "disable": false },
      { "label": "Shadowsocks", "value": "shadowsocks", "disable": true }
    ];
    this.proxy_form._form.resetFields();
    this.controller.clear();
    this.$emit("refresh");
  }
};
__decorateClass([
  Ref("proxyForm")
], ProxySettingsDialog.prototype, "proxy_form", 2);
__decorateClass([
  Debounce(400)
], ProxySettingsDialog.prototype, "submit", 1);
ProxySettingsDialog = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit,
      UiDialog,
      PasswordInput
    }
  })
], ProxySettingsDialog);
export {
  ProxySettingsDialog as default
};
